import { MainContainer } from '@/components';
import { recheckProcessTranslation } from '@/helpers/recheckProcessTranslation';
import { useTranslation } from '@/hooks';
import { Helmet } from 'react-helmet';

import PageHeader from '../PageHeader';

export function VerificationSuccess() {
  const { translate } = useTranslation({ useAnonymously: true });

  return (
    <>
      <Helmet>
        <title>{translate('identityVerificationSuccess', recheckProcessTranslation)}</title>
      </Helmet>
      <MainContainer>
        <PageHeader title={translate('thanks', recheckProcessTranslation)} />
        <p>{translate('recheckIdConnected', recheckProcessTranslation)}</p>
      </MainContainer>
    </>
  );
}
